<template>
	<v-container>
		<v-row class="contentRow">
			<v-col>
				<h1 class="mb-2">Pending Invitations</h1>
				<p class="mb-10 text-center">This is a list of invitations you have sent to other companies.</p>
				<v-data-table
					:loading="loading"
					theme--
					light
					:headers="headers"
					:items="invitations"
					:items-per-page="5"
					:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
					class="light table"
				>
					<template  v-slot:item.expiryDate="{ item }">
						<p  v-if="new Date(item.expiryDate).getTime() < Date.now()" style="color: red ;margin-bottom: 0px">{{item.expiryDate}}
							<v-icon   color="red" style="margin:5px" >fas fa-times-circle</v-icon>
						</p>
						<p v-else style="margin-bottom: 0px">{{item.expiryDate}}</p>
					</template>
					<template v-slot:item.remove="{ item }">
						<v-btn color="red" v-on:click="showDeleteDialog(item)">
							<v-icon color="white" small>fas fa-times</v-icon>
						</v-btn>
					</template>
				</v-data-table>
			</v-col>
			<v-dialog v-model="dialogDelete" max-width="500px">
				<v-card>
					<v-card-title>Are you sure you want to revoke this invitation?</v-card-title>
					<v-card-actions>
						<v-btn color="primary" text @click="dialogDelete = false">Close</v-btn>
						<v-btn color="error" text @click="removeRow">Delete</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-row>
	</v-container>
</template>

<script>
import InvitationCodesAPI from "../../api/connections/invitationcodes"
import LoadingState from "../../consts/LoadingState"
import { mapState } from "vuex"
export default {
	name: "InvitationCodes",
	data() {
		return {
			headers: [
				{
					text: "Invitation Code",
					value: "invitationCode",
					sortable: false,
				},
				{ text: "Name", value: "name", sortable: true },
				{ text: "Expiry Date", value: "expiryDate", sortable: false },
				{ text: "Actions", value: "remove", sortable: false },
			],
			invitations: [],
			interval: null,
			type: null,
			invitationCode: null,
			name: null,
			expiryDate: null,
			formIsValid: false,
			types: [{ text: "", value: "" }],
			dialogDelete: false,
			itemToDelete: null,
		}
	},
	mounted() {
		this.loadItems()
	},
	methods: {
		loadItems() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			InvitationCodesAPI.listAll({ hasBeenRedeemed: false })
				.then((data) => {
					this.invitations = data.items
						.map((entry) => ({
							invitationCode: entry.invitationCode,
							name: entry.name,
							expiryDate: this.$moment(entry.expiryDate).format("DD/MM/YYYY HH:mm:ss"),
							expiryDateRaw: entry.expiryDate,
							remove: null,
						}))
						.sort((a, b) => new Date(b.expiryDateRaw) - new Date(a.expiryDateRaw))

					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		setSendingFalse: function () {
			this.isSending = false
		},
		removeRow() {
			this.dialogDelete = false
			let index = this.invitations.indexOf(this.itemToDelete)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			InvitationCodesAPI.deleteInvitationCode(
				this.itemToDelete.invitationCode
			)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Invitation was successfully removed from the list.",
						{ root: true }
					)
					this.invitations.splice(index, 1)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		showDeleteDialog(item) {
			this.itemToDelete = item
			this.dialogDelete = !this.dialogDelete
		},
	},
	computed: {
		...mapState("loading", {
			loading: (state) => state.loading == LoadingState.LOADING,
		}),
	},
}
</script>